<template>
  <div class="main">
    <Navigation :allParksActive="allParksActive" />
    <router-view :cities="cities" :APIkey="APIkey"/>
  </div>
</template>

<script>
import axios from "axios";
import db from "./firebase/firebaseinit";
import Navigation from "./components/Navigation"
export default {
  name: "App",
  components: {
    Navigation,
  },
  data() {
    return {
      APIkey: "3b97256819c9b05c67ac5010d4027663",
      cities: [],
      allParksActive: null,
      order:  ['Anaheim', 'Orlando', 'Paris', 'Hong Kong', 'Shanghai', 'Tokyo'],
    }
  },
  created() {  
    this.checkRoute();
    this.getCityWeather();
  },
  methods: {
    getCityWeather(){
      let firebaseDB = db.collection("cities");
      firebaseDB.onSnapshot((snap) => {
        snap.docChanges().forEach(async (doc) => {
          var day = new Date().getHours();
          var time = new Date(doc.doc.data().currentWeather.dt * 1000).getHours();
          var difference = day - time;
          if (doc.type === "added" && difference != 0) {
            try{
              const response = await axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${doc.doc.data().city}&units=metric&appid=${this.APIkey}`);
              const data = response.data;
              await firebaseDB
                .doc(doc.doc.id)
                .update({
                  currentWeather: data,
                })
                .then(() => firebaseDB.doc(doc.doc.id).get())
                .then((updatedDoc) => {
                  this.cities.push(updatedDoc.data())
                });
                const result = this.cities.sort((itemA, itemB) => {
                  const cityA = itemA.city;
                  const cityB = itemB.city;
                 
                  const indexA = this.order.indexOf(cityA);
                  const indexB = this.order.indexOf(cityB);

                  return indexB < indexA ? 1 : -1;
                });
                result;

            } catch(err) {
              console.log(err);
            }
          }else if (doc.type === "added" && difference == 0) {
            this.cities.push(doc.doc.data())
          }
      });
    });
    },
    checkRoute() {
      if (this.$route.name === "AllParks") {
        this.allParksActive = true;
      }else {
        this.allParksActive = false;
      }
    },
  },
  watch: {
    $route() {
      this.checkRoute();
    }
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Quicksand', sans-serif; 
}
body {
  background-image: url('../public/chateaunuit.jpg');
  background-size: contain;
  
}

.day {
    transition: 500ms ease all;
    background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.main {
  height: 100vh;
  max-width: 1024px;
  margin: 0 auto;
  .container {
    padding: 0 20px;
    
  }
}
</style>
